<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>View Item</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="px-3 py-4">
  <p id="name">{{ pivot.item?.name }}</p>

  <p>{{ pivot.item?.question }}</p>
  <p>{{ pivot.answer == 'NA' ? 'Not Applicable' : pivot.answer}}</p>

  <h6>Status</h6>
  <p>{{ pivot.status }}</p>

  <div class="mb-2" *ngIf="pivot.rating">
    <h6>Rating</h6>
    <app-rating [rating]="pivot.rating"></app-rating>
  </div>

  <ng-container *ngIf="pivot.expiry">
    <h6>Expiry</h6>
    <p [ngClass]="getExpiryClass(pivot.expiry)">{{ (pivot.expiry * 1000) | timezoneConvertShort }}</p>
  </ng-container>

  <h6 *ngIf="pivot.notes">Notes</h6>
  <p id="note">{{ pivot.notes }}</p>

  <h6 *ngIf="pivot.files?.length">Files</h6>
  <app-files-list [files]="pivot.files" [view]="true"></app-files-list>
</mat-dialog-content>
